﻿/*-----------------------------------------------------------------------------------
' Module Name:   common.js
' Description:   Contains common javascript and jQuery methods.
' Author:        Mike Myers
' Date:          2/2/10
'----------------------------------------------------------------------------------*/

function HandleAjaxError(xhr, status, err) {
    switch (xhr.status) {
        case 520: // session timeout
            location.href = xhr.statusText;
            break;
        case 550: // 0 rows returned from db
            alert(xhr.statusText);
            break;
    }
}

// Used in Sultan to return to setup page
function returnToPage(page) {
    switch (page) {
        case 'setup':
            window.location = 'set.asp';
            break;
        case 'back':
            window.history.back();
            break;
    }
}
